import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import useAuth from '../../hooks/useAuth';
import oidcConfig from '../../oidcConfig';
import { parseExampleIdFromSearchURI } from '../../utils/templateGenerator';
import { setLinkedExample } from '../../store/ExampleGallery/actions';

const RequireAuth = ({ children, onSetLinkedExample }) => {
  const auth = useAuth();
  const location = useLocation();

  if (window.localStorage) {
    // The exampleId parsed will be lower cased
    const exampleId = parseExampleIdFromSearchURI(location.search);
    if (exampleId) {
      onSetLinkedExample(exampleId);
    }
  }
  if (oidcConfig.requireAuth && !auth.tokenResponse) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onSetLinkedExample: PropTypes.func.isRequired,
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSetLinkedExample: setLinkedExample,
    },
    dispatch,
  );
}
export default connect(null, mapDispatchToProps)(RequireAuth);
